module.exports = __webpack_public_path__ + "img/title.0d9f1657.png";